import { Link } from 'react-router-dom';
import { stats } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20luxurious%20gaming%20lounge%20with%20golden%20accents%20and%20warm%20ambient%20lighting%2C%20abstract%20geometric%20patterns%20on%20dark%20walls%2C%20elegant%20casino%20atmosphere%20with%20soft%20red%20and%20gold%20highlights%2C%20premium%20gaming%20environment%2C%20cinematic%20composition%2C%20dramatic%20lighting%2C%20no%20people%2C%20sophisticated%20and%20modern&width=1920&height=1080&seq=hero-bg-jiuyou&orientation=landscape"
          alt="九游娱乐游戏平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-shield-check-line text-accent-400 text-sm"></i>
            <span className="text-background-50/90 text-xs md:text-sm font-medium">官方正版 · 安全可靠 · 千万玩家信赖之选</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight mb-5">
            畅享多元游戏世界
            <br />
            <span className="text-accent-400">极致娱乐体验</span> 尽在九游
          </h1>

          <p className="text-background-100/80 text-sm md:text-base max-w-2xl mx-auto mb-8 leading-relaxed">
            九游娱乐汇聚海量精品游戏，涵盖电子游艺、真人视讯、体育电竞、棋牌捕鱼等多元品类。
            丰厚福利活动不间断，专业客服全天候护航，为您打造安全稳定的极致娱乐平台。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="#"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即注册 · 领新人豪礼
            </a>
            <Link
              to="/category/all"
              className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-background-50/15 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium text-sm hover:bg-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览全部游戏
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-14 max-w-3xl mx-auto">
            {stats.map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="w-10 h-10 md:w-11 md:h-11 mx-auto mb-2 rounded-xl bg-background-50/10 backdrop-blur-sm border border-background-50/15 flex items-center justify-center">
                  <i className={`${stat.icon} text-accent-400 text-base md:text-lg`}></i>
                </div>
                <div className="font-heading font-bold text-xl md:text-2xl text-background-50">{stat.value}</div>
                <div className="text-background-100/60 text-xs mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}